export default __webpack_public_path__ + "images/VH.d6913e8.png";